import { IdResourceCollectionStore } from './ResourceCollectionStore';
import { SshKey } from '../ApiModel';
import { IApiClient } from '../ApiClient';
import { IResourceSession } from './ResourceSession';
import { loadAllItems } from '../helper/PagingHelper';

export type SshKeyInfo = { name: string; default: boolean; public_key: string };

export class SshKeysStore extends IdResourceCollectionStore<SshKey> {
    constructor(
        private apiClient: IApiClient,
        session?: IResourceSession<SshKey>
    ) {
        super({
            getItems: () => loadAllItems((link) => apiClient.getSshKeys(link)),
            session: session,
        });
    }

    async createSshKey(values: SshKeyInfo): Promise<SshKey> {
        return this.addItem(await this.apiClient.createSshKey(values));
    }

    async updateSshKey(id: number, values: SshKeyInfo): Promise<SshKey> {
        return this.updateItem(await this.apiClient.updateSshKey(id, values));
    }

    async deleteSshKey(id: number): Promise<void> {
        await this.apiClient.deleteSshKey(id);
        this.deleteItem(id);
    }
}
